// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bulk-add-members__title{
   margin-bottom: var(--space-x2);
   display: flex;
   align-items: center;
}

.bulk-add-members__title.baloa-subtitle-2 {
    color: var( --primary-very-dark-color );
}

.baloa-table.bulk-add-members__text {
    color: var(--primary-very-dark-color);    
}

.bulk-add-members__buttons{
   margin-top: var(--space-x2);
   /* display: flex;
   justify-content: space-between; */
   margin-bottom: var(--space);
}

.bulk-add-members__container {
   padding-top: var(--space-x3);
   padding-left: var(--space-x3);
   padding-right: var(--space-x3);
   padding-bottom: var(--space);
}

.bulk-add-members__buttons__template-buttons{
    display: flex;
    justify-content: flex-start;
}

.bulk-add-members__buttons__back{
    display: flex;
    justify-content: end;
   
}
.bulk-add-members__buttons__back__button{
    font-size: var(--space);
    padding: calc((var(--space-half))) calc((var(--space-and-half)));
    margin-left: var(--space); 
    cursor: pointer;
}

.bulk-add-members__buttons__button{
   font-size: var(--space);
   /*opacity: 0.64;*/
   padding: calc((var(--space-half))) calc((var(--space-and-half)));
   margin-left: auto;
}

.bulk-add-members__buttons__button-middle{
   font-size: var(--space);
   margin-left: calc( var(--space-x2) - var(--space-quarter));
   padding: calc((var(--space-half))) calc((var(--space-and-half)));
}

.bulk-add-members__buttons__button__download-button{
    border: 2px solid var(--new-green-color);
    background: #FFFFFF;
    box-sizing: border-box;
    border-radius: 6px;    
    font-size: var(--space);
    color: var(--new-green-color);
    padding: calc((var(--space-half))) calc((var(--space-and-half)));
}

.bulk-add-members__template-area {
   display: flex;
   
   /* background: var(--new-template-area-color); */
   height: calc((var(--space)*27));
   /* border-radius: calc((var(--space-quarter)*3)); */
   color: var(--basic-gray-color) !important;
   justify-content: center;
   align-items: center;
}

.bulk-add-members__member-data{   
   margin: var(--space-quarter) var(--space-half);
   padding-left: var(--space-half);

}

.bulk-add-members__member-data-num{   
   text-align: center;

}

.bulk-add-members__member-data__container{
    margin-bottom: var(--space-and-half);
    box-shadow: 0px 1px 4px rgba(68, 68, 68, 0.25);
    border-radius: 12px;     
}

.bulk-add-members__error-message{
    background: #FFC7CA;
    border-radius: 5px;
    display: flex;
    padding: var(--space-half);
    margin-bottom: var(--space);
}

.bulk-add-members__error-message.baloa-table {
    color: var( --primary-very-dark-color );
}

.bulk-add-members-memeber-data__table {
   background: var(--white-color);
   /* box-shadow: 0px 1px 4px rgba(68, 68, 68, 0.25);
   border-radius: 12px;  */  
   width: 100%;
   padding: var(--space-half);   
}

.bulk-add-members__member-data__headers{
    background-color: var(--new-table-header-color);
    height: var( --space-x3 );
}

.bulk-add-members__member-data__header.baloa-table-column {
   color: var( --basic-gray-color );
   text-align: left;
   padding-left: var( --space-half );
}


.bulk-add-members__member-data__row{    
   /*
    margin-top: calc(var(--space-half-quarter)*40);
    margin-bottom: calc(var(--space-half-quarter)*40);
    */
    height: var(--space-x2);
}

.bulk-add-members__member-data__row td.baloa-table {
    color: var( --primary-dark-color );
}



.bulk-add-members__member-data.data-error{
    border: var(--input-field-border-error);
    border-radius: 5px;
    margin: var(--space-half) var(--space-half);
    display: flex;
    justify-content: space-between;
}

.icon-arrow-left.bulk-add-members_icon-back{
    color: var(--primary-very-dark-color);
    font-size: var(--space-and-half);
    margin-right: calc(var(--space) + var(--space-quarter));
    cursor: pointer;
}

.bulk-add-members__loader{   
   margin-top: var(--space);
   background: var(--new-template-area-color);
   height: calc((var(--space) * 27));
   border-radius: calc((var(--space-quarter) * 3));
   color: var(--basic-gray-color) !important;
   justify-content: center;
   align-items: center;
   padding-top:calc((var(--space) * 8));
}

.bulk-add-members__loader-bar {
   width: 50%;
   margin-left: auto;
   margin-right: auto;   
   margin-top: var(--space-x2);   
}


.bulk-add-members__loader-msg{
    margin-top: calc(var(--space));
    margin-bottom: calc(var(--space) + var(--space-quarter));
    text-align: center;
}

.bulk-add-members__loader-msg.baloa-headline-5{
    color: var(--primary-very-dark-color) !important;
}

.bulk-add-members__loader .MuiLinearProgress-colorPrimary {
    background-color: var(--white-color);
    height: var(--space-half-quarter);
}

.bulk-add-members__loader .MuiLinearProgress-colorPrimary .MuiLinearProgress-barColorPrimary{
    background-color: #60E194;
    height: var(--space-half-quarter);
}

.bulk-add-members__member-data-num__container {
    display: flex;
    justify-content: center;
}

.bulk-add-members__member-data__icon-edit{
    cursor: pointer;
}

.bulk-add-members__member-data__icon-edit img{
    width: 17px;
}

.bulk-add-members__member-data__icon-delete.icon-x{
    font-size: 12px;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    color: var(--primary-dark-color);
    background: var(--new-gray-background-color);
    border-radius: 50%;
    cursor: pointer;
}

.bulk-add-members__member-data__icon-save.icon-check-single-72{
    font-size: 18px;
    padding: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    color: var(--white-color);
    background: var(--new-green-color);
    border-radius: 50%;
    cursor: pointer;
}

.bulk-add-members__member-data__edit{
    margin: 0 10px;
}

.bulk-add-members__separator {
    /* height: 0; */
    border: 1px solid var( --new-gray-background-color );
    margin: 14px 0;
}

.button.bulk-add-members__buttons__button span.icon{
    grid-area: icon;
    margin-right: 10px;
}

.bulk-add-members__buttons__button__save-button{
    padding: unset;
}

.bulk-add-members-memeber-data__table .input-field{
    margin: 5px 0;
}

.bulk-add-members__member-data__edit__ccode{
    width: 40px
}

.bulk-add-members__member-data__edit__ccode .input-field-input{
    padding-left: 5px;
    padding-right: 0;
}

.bulk-add-members__member-data__empty-contact {
    border: 1px solid var(--primary-dark-color);
    border-radius: 4px;
    text-align: end;
}

.bulk-add-members__text__link{
    color: var(--new-green-color);
    cursor: pointer;
}

.bulk-add-members__loading {
    border: 3px solid var(--primary-very-light-color); 
    border-top: 3px solid var(--basic-green-color);
    border-radius: 50%;
    width: 24px;
    height: 24px;
    animation: spin 2s linear infinite;
    margin: 0 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-bulk-add-members/LeagueBulkAddMembersComponent.styles.css"],"names":[],"mappings":"AAAA;GACG,8BAA8B;GAC9B,aAAa;GACb,mBAAmB;AACtB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,qCAAqC;AACzC;;AAEA;GACG,2BAA2B;GAC3B;oCACiC;GACjC,2BAA2B;AAC9B;;AAEA;GACG,4BAA4B;GAC5B,6BAA6B;GAC7B,8BAA8B;GAC9B,4BAA4B;AAC/B;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,oBAAoB;;AAExB;AACA;IACI,uBAAuB;IACvB,gEAAgE;IAChE,yBAAyB;IACzB,eAAe;AACnB;;AAEA;GACG,uBAAuB;GACvB,iBAAiB;GACjB,gEAAgE;GAChE,iBAAiB;AACpB;;AAEA;GACG,uBAAuB;GACvB,0DAA0D;GAC1D,gEAAgE;AACnE;;AAEA;IACI,wCAAwC;IACxC,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,6BAA6B;IAC7B,gEAAgE;AACpE;;AAEA;GACG,aAAa;;GAEb,gDAAgD;GAChD,+BAA+B;GAC/B,mDAAmD;GACnD,yCAAyC;GACzC,uBAAuB;GACvB,mBAAmB;AACtB;;AAEA;GACG,8CAA8C;GAC9C,+BAA+B;;AAElC;;AAEA;GACG,kBAAkB;;AAErB;;AAEA;IACI,oCAAoC;IACpC,8CAA8C;IAC9C,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;GACG,8BAA8B;GAC9B;0BACuB;GACvB,WAAW;GACX,0BAA0B;AAC7B;;AAEA;IACI,+CAA+C;IAC/C,yBAAyB;AAC7B;;AAEA;GACG,gCAAgC;GAChC,gBAAgB;GAChB,iCAAiC;AACpC;;;AAGA;GACG;;;KAGE;IACD,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;;;AAIA;IACI,uCAAuC;IACvC,kBAAkB;IAClB,2CAA2C;IAC3C,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;IAChC,uDAAuD;IACvD,eAAe;AACnB;;AAEA;GACG,wBAAwB;GACxB,0CAA0C;GAC1C,iCAAiC;GACjC,+CAA+C;GAC/C,yCAAyC;GACzC,uBAAuB;GACvB,mBAAmB;GACnB,oCAAoC;AACvC;;AAEA;GACG,UAAU;GACV,iBAAiB;GACjB,kBAAkB;GAClB,2BAA2B;AAC9B;;;AAGA;IACI,8BAA8B;IAC9B,wDAAwD;IACxD,kBAAkB;AACtB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,oCAAoC;IACpC,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,4CAA4C;IAC5C,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,oDAAoD;IACpD,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,iDAAiD;IACjD,8CAA8C;IAC9C,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,cAAc;AAClB","sourcesContent":[".bulk-add-members__title{\n   margin-bottom: var(--space-x2);\n   display: flex;\n   align-items: center;\n}\n\n.bulk-add-members__title.baloa-subtitle-2 {\n    color: var( --primary-very-dark-color );\n}\n\n.baloa-table.bulk-add-members__text {\n    color: var(--primary-very-dark-color);    \n}\n\n.bulk-add-members__buttons{\n   margin-top: var(--space-x2);\n   /* display: flex;\n   justify-content: space-between; */\n   margin-bottom: var(--space);\n}\n\n.bulk-add-members__container {\n   padding-top: var(--space-x3);\n   padding-left: var(--space-x3);\n   padding-right: var(--space-x3);\n   padding-bottom: var(--space);\n}\n\n.bulk-add-members__buttons__template-buttons{\n    display: flex;\n    justify-content: flex-start;\n}\n\n.bulk-add-members__buttons__back{\n    display: flex;\n    justify-content: end;\n   \n}\n.bulk-add-members__buttons__back__button{\n    font-size: var(--space);\n    padding: calc((var(--space-half))) calc((var(--space-and-half)));\n    margin-left: var(--space); \n    cursor: pointer;\n}\n\n.bulk-add-members__buttons__button{\n   font-size: var(--space);\n   /*opacity: 0.64;*/\n   padding: calc((var(--space-half))) calc((var(--space-and-half)));\n   margin-left: auto;\n}\n\n.bulk-add-members__buttons__button-middle{\n   font-size: var(--space);\n   margin-left: calc( var(--space-x2) - var(--space-quarter));\n   padding: calc((var(--space-half))) calc((var(--space-and-half)));\n}\n\n.bulk-add-members__buttons__button__download-button{\n    border: 2px solid var(--new-green-color);\n    background: #FFFFFF;\n    box-sizing: border-box;\n    border-radius: 6px;    \n    font-size: var(--space);\n    color: var(--new-green-color);\n    padding: calc((var(--space-half))) calc((var(--space-and-half)));\n}\n\n.bulk-add-members__template-area {\n   display: flex;\n   \n   /* background: var(--new-template-area-color); */\n   height: calc((var(--space)*27));\n   /* border-radius: calc((var(--space-quarter)*3)); */\n   color: var(--basic-gray-color) !important;\n   justify-content: center;\n   align-items: center;\n}\n\n.bulk-add-members__member-data{   \n   margin: var(--space-quarter) var(--space-half);\n   padding-left: var(--space-half);\n\n}\n\n.bulk-add-members__member-data-num{   \n   text-align: center;\n\n}\n\n.bulk-add-members__member-data__container{\n    margin-bottom: var(--space-and-half);\n    box-shadow: 0px 1px 4px rgba(68, 68, 68, 0.25);\n    border-radius: 12px;     \n}\n\n.bulk-add-members__error-message{\n    background: #FFC7CA;\n    border-radius: 5px;\n    display: flex;\n    padding: var(--space-half);\n    margin-bottom: var(--space);\n}\n\n.bulk-add-members__error-message.baloa-table {\n    color: var( --primary-very-dark-color );\n}\n\n.bulk-add-members-memeber-data__table {\n   background: var(--white-color);\n   /* box-shadow: 0px 1px 4px rgba(68, 68, 68, 0.25);\n   border-radius: 12px;  */  \n   width: 100%;\n   padding: var(--space-half);   \n}\n\n.bulk-add-members__member-data__headers{\n    background-color: var(--new-table-header-color);\n    height: var( --space-x3 );\n}\n\n.bulk-add-members__member-data__header.baloa-table-column {\n   color: var( --basic-gray-color );\n   text-align: left;\n   padding-left: var( --space-half );\n}\n\n\n.bulk-add-members__member-data__row{    \n   /*\n    margin-top: calc(var(--space-half-quarter)*40);\n    margin-bottom: calc(var(--space-half-quarter)*40);\n    */\n    height: var(--space-x2);\n}\n\n.bulk-add-members__member-data__row td.baloa-table {\n    color: var( --primary-dark-color );\n}\n\n\n\n.bulk-add-members__member-data.data-error{\n    border: var(--input-field-border-error);\n    border-radius: 5px;\n    margin: var(--space-half) var(--space-half);\n    display: flex;\n    justify-content: space-between;\n}\n\n.icon-arrow-left.bulk-add-members_icon-back{\n    color: var(--primary-very-dark-color);\n    font-size: var(--space-and-half);\n    margin-right: calc(var(--space) + var(--space-quarter));\n    cursor: pointer;\n}\n\n.bulk-add-members__loader{   \n   margin-top: var(--space);\n   background: var(--new-template-area-color);\n   height: calc((var(--space) * 27));\n   border-radius: calc((var(--space-quarter) * 3));\n   color: var(--basic-gray-color) !important;\n   justify-content: center;\n   align-items: center;\n   padding-top:calc((var(--space) * 8));\n}\n\n.bulk-add-members__loader-bar {\n   width: 50%;\n   margin-left: auto;\n   margin-right: auto;   \n   margin-top: var(--space-x2);   \n}\n\n\n.bulk-add-members__loader-msg{\n    margin-top: calc(var(--space));\n    margin-bottom: calc(var(--space) + var(--space-quarter));\n    text-align: center;\n}\n\n.bulk-add-members__loader-msg.baloa-headline-5{\n    color: var(--primary-very-dark-color) !important;\n}\n\n.bulk-add-members__loader .MuiLinearProgress-colorPrimary {\n    background-color: var(--white-color);\n    height: var(--space-half-quarter);\n}\n\n.bulk-add-members__loader .MuiLinearProgress-colorPrimary .MuiLinearProgress-barColorPrimary{\n    background-color: #60E194;\n    height: var(--space-half-quarter);\n}\n\n.bulk-add-members__member-data-num__container {\n    display: flex;\n    justify-content: center;\n}\n\n.bulk-add-members__member-data__icon-edit{\n    cursor: pointer;\n}\n\n.bulk-add-members__member-data__icon-edit img{\n    width: 17px;\n}\n\n.bulk-add-members__member-data__icon-delete.icon-x{\n    font-size: 12px;\n    padding: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 20px;\n    height: 20px;\n    color: var(--primary-dark-color);\n    background: var(--new-gray-background-color);\n    border-radius: 50%;\n    cursor: pointer;\n}\n\n.bulk-add-members__member-data__icon-save.icon-check-single-72{\n    font-size: 18px;\n    padding: 2px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 20px;\n    height: 20px;\n    color: var(--white-color);\n    background: var(--new-green-color);\n    border-radius: 50%;\n    cursor: pointer;\n}\n\n.bulk-add-members__member-data__edit{\n    margin: 0 10px;\n}\n\n.bulk-add-members__separator {\n    /* height: 0; */\n    border: 1px solid var( --new-gray-background-color );\n    margin: 14px 0;\n}\n\n.button.bulk-add-members__buttons__button span.icon{\n    grid-area: icon;\n    margin-right: 10px;\n}\n\n.bulk-add-members__buttons__button__save-button{\n    padding: unset;\n}\n\n.bulk-add-members-memeber-data__table .input-field{\n    margin: 5px 0;\n}\n\n.bulk-add-members__member-data__edit__ccode{\n    width: 40px\n}\n\n.bulk-add-members__member-data__edit__ccode .input-field-input{\n    padding-left: 5px;\n    padding-right: 0;\n}\n\n.bulk-add-members__member-data__empty-contact {\n    border: 1px solid var(--primary-dark-color);\n    border-radius: 4px;\n    text-align: end;\n}\n\n.bulk-add-members__text__link{\n    color: var(--new-green-color);\n    cursor: pointer;\n}\n\n.bulk-add-members__loading {\n    border: 3px solid var(--primary-very-light-color); \n    border-top: 3px solid var(--basic-green-color);\n    border-radius: 50%;\n    width: 24px;\n    height: 24px;\n    animation: spin 2s linear infinite;\n    margin: 0 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
